export default {
  mapboxAccessToken: "pk.eyJ1IjoibG91cGRlbGFqdW5nbGUiLCJhIjoiY2tmZ3QxZjB5MGVlcDJxczJyNm9kZmo2ZiJ9.57VQ8zp8k8ve5MgYg2J1BA" // add restrictions
                    //pk.eyJ1IjoibG91cGRlbGFqdW5nbGUiLCJhIjoiY2tmZ21lNXA1MGNsYTJ5czJseDdxcDhrdCJ9.Dq2rJcK5WJqMSqT71LJruA
}